import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Client = () => (
  <MfeLoader port={process.env.NX_CLIENT_CONFIG_MFE_PORT!} mfeId={FEATURE_APP_ID.CLIENT_CONFIG_MFE} />
)

export default Client
